<template>
  <main class="main-page">
    <template v-if="showHeader">
      <section class="page-section">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold">Edit Message</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
    </template>
    <section class="page-section">
      <div class="container">
        <div class="grid">
          <div class="md:col-9 sm:col-12 comp-grid">
            <div>
              <template v-if="pageReady">
                <form
                  ref="observer"
                  tag="form"
                  @submit.prevent="submitForm()"
                  :class="{ card: !isSubPage }"
                  class=""
                >
                  <!--[form-content-start]-->
                  <div class="grid">
                    <div class="col-12 md:col-6">
                      <div class="mb-2 font-bold text-sm">Category *</div>
                      <div id="ctrl-feed_type-holder">
                        <Dropdown
                          class="w-full"
                          :class="getErrorClass('feed_type')"
                          optionLabel="label"
                          optionValue="value"
                          ref="ctrlfeed_type"
                          v-model="formData.feed_type"
                          :options="app.menus.feedTypeItems"
                          label="Feed Type"
                          placeholder="Select a value ..."
                        >
                        </Dropdown>
                        <small
                          v-if="isFieldValid('feed_type')"
                          class="p-error"
                          >{{ getFieldError("feed_type") }}</small
                        >
                      </div>
                    </div>
                    <div class="col-12 md:col-6">
                      <div class="mb-2 font-bold text-sm">Author *</div>
                      <div id="ctrl-author-holder">
                        <InputText
                          ref="ctrlauthor"
                          v-model.trim="formData.author"
                          label="Author"
                          type="text"
                          placeholder="Enter Author"
                          class="w-full"
                          :class="getErrorClass('author')"
                        >
                        </InputText>
                        <small v-if="isFieldValid('author')" class="p-error">{{
                          getFieldError("author")
                        }}</small>
                      </div>
                    </div>
                    <div class="col-12 md:col-12">
                      <div class="mb-2 font-bold text-sm">Title *</div>
                      <div id="ctrl-title-holder">
                        <InputText
                          ref="ctrltitle"
                          v-model.trim="formData.title"
                          label="Title"
                          type="text"
                          placeholder="Enter Title"
                          class="w-full"
                          :class="getErrorClass('title')"
                        >
                        </InputText>
                        <small v-if="isFieldValid('title')" class="p-error">{{
                          getFieldError("title")
                        }}</small>
                      </div>
                    </div>
                    <div class="col-12 md:col-12">
                      <div class="mb-2 font-bold text-sm">Message *</div>
                      <div id="ctrl-message-holder">
                        <Textarea
                          :class="getErrorClass('message')"
                          class="w-full"
                          ref="ctrlmessage"
                          rows="5"
                          v-model="formData.message"
                          placeholder="Enter Message"
                          type="textarea"
                        >
                        </Textarea>
                        <small v-if="isFieldValid('message')" class="p-error">{{
                          getFieldError("message")
                        }}</small>
                      </div>
                    </div>
                    <!-- <div class="col-12 md:col-6">
                      <div class="mb-2 font-bold text-sm">Target Region</div>
                      <div id="ctrl-target_region-holder">
                        <MultiSelect
                          class="w-full"
                          :class="getErrorClass('target_region')"
                          optionLabel="label"
                          optionValue="value"
                          ref="ctrltarget_region"
                          v-model="formData.target_region"
                          :options="[]"
                          label="Target Region"
                        >
                        </MultiSelect>
                        <small
                          v-if="isFieldValid('target_region')"
                          class="p-error"
                          >{{ getFieldError("target_region") }}</small
                        >
                      </div>
                    </div>
                    <div class="col-12 md:col-6">
                      <div class="mb-2 font-bold text-sm">Target District</div>
                      <div id="ctrl-target_district-holder">
                        <MultiSelect
                          class="w-full"
                          :class="getErrorClass('target_district')"
                          optionLabel="label"
                          optionValue="value"
                          ref="ctrltarget_district"
                          v-model="formData.target_district"
                          :options="[]"
                          label="Target District"
                        >
                        </MultiSelect>
                        <small
                          v-if="isFieldValid('target_district')"
                          class="p-error"
                          >{{ getFieldError("target_district") }}</small
                        >
                      </div>
                    </div> -->
                    <div class="col-12 md:col-12">
                      <div class="mb-2 font-bold text-sm">Attach Image(s)</div>
                      <div id="ctrl-media-holder">
                        <div class="mb-3">
                          <Uploader
                            :class="getErrorClass('media')"
                            upload-path="s3uploader/upload/media"
                            v-model="formData.media"
                            :fileLimit="7"
                            :maxFileSize="3000000"
                            accept=".jpg,.png,.gif,.jpeg"
                            :multiple="true"
                            label="Choose files or drop files here"
                          />
                        </div>
                        <small v-if="isFieldValid('media')" class="p-error">{{
                          getFieldError("media")
                        }}</small>
                      </div>
                    </div>
                  </div>
                  <!--[form-content-end]-->
                  <div v-if="showSubmitButton" class="text-center my-3">
                    <Button
                      type="submit"
                      label="Update"
                      icon="pi pi-send"
                      :loading="saving"
                    />
                  </div>
                </form>
              </template>
              <template v-if="loading">
                <div class="p-3 text-center">
                  <ProgressSpinner style="width: 50px; height: 50px" />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script setup>
import { computed, reactive, toRefs, onMounted } from "vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@/services/validators";
import { useApp } from "@/composables/app.js";
import { useEditPage } from "@/composables/editpage.js";
const props = defineProps({
  id: [String, Number],
  pageName: {
    type: String,
    default: "feeds",
  },
  routeName: {
    type: String,
    default: "feedsedit",
  },
  pagePath: {
    type: String,
    default: "feeds/edit",
  },
  apiPath: {
    type: String,
    default: "feeds/edit",
  },
  submitButtonLabel: {
    type: String,
    default: "Update",
  },
  formValidationError: {
    type: String,
    default: "Form is invalid",
  },
  formValidationMsg: {
    type: String,
    default: "Please complete the form",
  },
  msgTitle: {
    type: String,
    default: "Update Record",
  },
  msgBeforeSave: {
    type: String,
    default: "",
  },
  msgAfterSave: {
    type: String,
    default: "Record updated successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showSubmitButton: {
    type: Boolean,
    default: true,
  },
  redirect: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp();
const formDefaultValues = Object.assign(
  {
    feed_type: "",
    author: "",
    title: "",
    message: "",
    media: "",
    target_region: [],
    target_district: [],
  },
  props.pageData
);
const formData = reactive({ ...formDefaultValues });
function onFormSubmited(response) {
  app.flashMsg(props.msgAfterUpdate);
  if (props.redirect) app.navigateTo(`/feeds`);
}
const rules = computed(() => {
  return {
    feed_type: { required },
    author: { required },
    title: { required },
    message: { required },
    media: {},
    target_region: {},
    target_district: {},
  };
});
const v$ = useVuelidate(rules, formData); //form validation
const page = useEditPage(props, formData, v$, onFormSubmited);
//page state
const {
  submitted, // form api submitted state - Boolean
  saving, // form api submiting state - Boolean
  loading, // form data loading state - Boolean
  pageReady, // if api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  apiUrl, // page current api path
  currentRecord, // current page record  - Object
} = page.computedProps;
//page methods
const {
  load, // get editable form data from api
  submitForm, // submit form data to api
  getErrorClass, // return error class if field is invalid- args(fieldname)
  getFieldError, //  get validation error message - args(fieldname)
  isFieldValid, // check if field is validated - args(fieldname)
  // map api datasource  to Select options label-value
} = page.methods;
onMounted(() => {
  const pageTitle = "Edit Message";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
  load();
});
</script>
<style scoped></style>
